// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"378":"management","431":"reds","549":"browser","962":"home"}[chunkId] || chunkId) + "." + {"378":"c1b5d9ed","431":"1987ec42","496":"4b78e4cf","549":"e6cba8ca","627":"b59ac7c1","962":"3c116798"}[chunkId] + ".css";
};